"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _qs = _interopRequireDefault(require("qs"));

var _formValidation = require("../formValidation");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

define(['app', '../helpers/dropdown', 'axios', 'jquery'], function (app, Dropdown, axios, $) {
  return app.Marionette.ItemView.extend({
    template: false,
    ui: {
      topicTypeButton: '.radio-box-button',
      ideaButton: '#topic_content_type_idea',
      forumSelector: '.editor__subject',
      productAreaSelector: '.topic-create_product-areas',
      tagSelector: '[data-helper=input-tags]',
      notification: '.js-notification',
      submit: '.topic-create_submit button'
    },
    events: {
      'change @ui.topicTypeButton': 'onChangeTopicType',
      'submit @ui.submit': 'onSubmit',
      'click @ui.submit': 'onSubmit'
    },
    options: {
      type: 0,
      forumTree: []
    },

    /**
     *
     * @param options
     * @returns {exports}
     */
    initialize: function initialize() {
      this.currentType = this.getOption('type') || 0;
      this.groups = [4, 5, 6];
      this.ideationType = 2;
      return this;
    },
    onRender: function onRender() {
      this.setIdeationSpecifications();

      var queryParameters = _qs.default.parse(window.location.search, {
        ignoreQueryPrefix: true
      });

      if (queryParameters && queryParameters.type === 'idea') {
        this.ui.ideaButton.trigger('click');
      }
    },
    onSubmit: function onSubmit(e) {
      var _this$options = this.options,
          ideationV2 = _this$options.ideationV2,
          csrfToken = _this$options.csrfToken,
          spamPhrase = _this$options.spamPhrase,
          phrase = _this$options.phrase,
          contentPhrase = _this$options.contentPhrase,
          titlePhrase = _this$options.titlePhrase,
          tagsPhrase = _this$options.tagsPhrase,
          categoryPhrase = _this$options.categoryPhrase,
          productAreasV2Required = _this$options.productAreasV2Required;
      var errorMessage = phrase;
      var isIdeationV2Disabled = !ideationV2;
      var isNotIdeaType = this.currentType !== this.ideationType.toString();

      if (isIdeationV2Disabled || isNotIdeaType) {
        return;
      }

      e.stopPropagation();
      e.preventDefault();
      var requestData = {
        csrfToken: csrfToken,
        sticky: false,
        closed: false,
        hasAttachments: false
      };
      var formData = $('form.js-wysiwyg-form').serializeArray();
      var attachments = [];
      formData.forEach(function (_ref) {
        var name = _ref.name,
            value = _ref.value;

        if (name === 'topic[title]') {
          requestData.title = value;
        } else if (name === 'topic[firstPost][content]') {
          requestData.content = value;
        } else if (name === 'topic[tags]') {
          requestData.tags = value.split(',').filter(function (val) {
            return val !== '';
          });
        } else if (name === 'topic[productAreas]') {
          requestData.productAreaIds = value;
        } else if (name === 'topic[firstPost][attachments][]') {
          requestData.hasAttachments = true;
          attachments.push(JSON.parse(value));
        } else if (name === 'topic[forum]') {
          requestData.categoryId = Number(value);
        }
      });
      var errorMessages = (0, _formValidation.validateTopicForm)(requestData, _objectSpread(_objectSpread({}, this.options), {}, {
        showProductAreas: productAreasV2Required,
        showCategoriesForIdeas: true
      }));
      var canSubmit = errorMessages.length === 0;

      if (canSubmit) {
        axios.defaults.headers.common = {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': csrfToken
        };
        this.ui.submit[0].classList.add('is-loading');
        axios.post('/topic/newIdea', requestData).then( /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
            var isSpam, isPending, location, id, attempt, maxRetries;
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    this.ui.submit[0].classList.remove('is-loading');
                    isSpam = Boolean(Number(data.headers['is-spam']));
                    isPending = Boolean(Number(data.headers['is-pending']));

                    if (!(isSpam || isPending)) {
                      _context.next = 8;
                      break;
                    }

                    errorMessage = spamPhrase;
                    this.ui.notification[0].innerHTML = "<div class=\"box box__pad box--alert\"><ul><li>".concat(errorMessage, "</li></ul></div>");
                    this.ui.notification[0].scrollIntoView({
                      behavior: 'smooth',
                      block: 'start'
                    });
                    return _context.abrupt("return");

                  case 8:
                    location = data.headers.location;
                    id = location.split('/').pop();
                    attempt = 0;
                    maxRetries = 3;

                  case 12:
                    if (!(attempt < maxRetries)) {
                      _context.next = 29;
                      break;
                    }

                    _context.prev = 13;
                    _context.next = 16;
                    return axios.post("/attachment/saveToTopic?id=".concat(id, "&contentType=idea"), {
                      attachments: attachments
                    });

                  case 16:
                    return _context.abrupt("break", 29);

                  case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](13);
                    ++attempt;

                    if (!(maxRetries === attempt)) {
                      _context.next = 24;
                      break;
                    }

                    throw _context.t0;

                  case 24:
                    // eslint-disable-next-line no-console
                    console.log("saveAttachmentsToTopic: attempt(".concat(attempt, ") failed"));
                    _context.next = 27;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 500);
                    });

                  case 27:
                    _context.next = 12;
                    break;

                  case 29:
                    window.location.assign((0, _absoluteUrlRuntime.resolveUrl)("/ideas/".concat(id)));

                  case 30:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this, [[13, 19]]);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }().bind(this)).catch(function (error) {
          var _error$response, _error$response$data, _error$response2, _error$response2$data, _error$response3;

          var errorMessages = [];

          if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.field) === 'tags') {
            errorMessages.push(tagsPhrase);
          }

          if (error !== null && error !== void 0 && (_error$response2 = error.response) !== null && _error$response2 !== void 0 && (_error$response2$data = _error$response2.data) !== null && _error$response2$data !== void 0 && _error$response2$data.errors) {
            var fieldMessageMap = {
              title: titlePhrase,
              content: contentPhrase,
              categoryId: categoryPhrase
            };
            Object.keys(error.response.data.errors).forEach(function (field) {
              if (fieldMessageMap[field]) {
                errorMessages.push(fieldMessageMap[field]);
              }
            });
          }

          if ((error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 429) {
            var _error$response4, _error$response4$data;

            errorMessages.push(error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.errors[0]);
          }

          if (errorMessages.length === 0) {
            errorMessages.push(errorMessage);
          }

          var errorListItems = errorMessages.map(function (errorMsg) {
            return "<li>".concat(errorMsg, "</li>");
          }).join('');
          this.ui.submit[0].classList.remove('is-loading');
          this.ui.notification[0].innerHTML = "<div class=\"box box__pad box--alert\"><ul>".concat(errorListItems, "</ul></div>");
          this.ui.notification[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }.bind(this));
      } else {
        var errorListItems = errorMessages.map(function (errorMsg) {
          return "<li>".concat(errorMsg, "</li>");
        }).join('');
        this.ui.notification[0].innerHTML = "<div class=\"box box__pad box--alert\"><ul>".concat(errorListItems, "</ul></div>");
        this.ui.notification[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },

    /**
     * @param newType
     * @returns {exports}
     */
    switchTopicType: function switchTopicType(newType) {
      this.currentType = newType;
      this.setIdeationSpecifications();
      return this;
    },

    /**
     * Map topic type values to content types
     */
    getContentTypeFromTopicType: function getContentTypeFromTopicType(topicType) {
      var typeMapping = {
        '-1': 'question',
        '0': 'conversation',
        '2': 'idea'
      };
      return typeMapping[topicType] || 'question';
    },

    /**
     *
     * @param e
     * @returns {exports}
     */
    onChangeTopicType: function onChangeTopicType(e) {
      this.ui.topicTypeButton.removeClass('is-active').filter(e.currentTarget).addClass('is-active');
      this.switchTopicType(e.target.value); // Update CategorySelect contentType

      var contentType = this.getContentTypeFromTopicType(e.target.value);
      var event = new CustomEvent('topic:content_type_changed', {
        detail: {
          contentType: contentType
        }
      });
      document.dispatchEvent(event);
      return this;
    },
    setIdeationSpecifications: function setIdeationSpecifications() {
      var isIdea = this.options.ideationV2 && this.currentType === this.ideationType.toString();
      var showCategoryDropdownForIdeas = this.options.categoriesV2Ideation;

      if (isIdea) {
        $('body').addClass('type-idea');
        this.ui.productAreaSelector.show();

        if (!this.options.productAreas) {
          this.ui.tagSelector.hide();
        }

        if (showCategoryDropdownForIdeas) {
          this.ui.forumSelector.show();
        } else {
          this.ui.forumSelector.hide();
        }
      } else {
        $('body').removeClass('type-idea');
        this.ui.tagSelector.show();
        this.ui.productAreaSelector.hide();
        this.ui.forumSelector.show();
      }
    }
  });
});